import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f498f3a")

_pushScopeId("data-v-5f498f3a")
const _hoisted_1 = {
  key: 0,
  class: "mission br-lg px-12"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_ctx.pending)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.mission), {
          onForbiddenClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.useClose = false)),
          onDone: _ctx.refresh
        }, null, 8, ["onDone"])),
        (_ctx.useClose)
          ? (_openBlock(), _createBlock("span", {
              key: 0,
              class: "close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next()))
            }, [
              _createVNode(_component_Icon, { name: "close" })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})